import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'BillableStatusPicker',
  props: {
    value: {
      default: 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    defaultLabel: {
      type: String,
      default: ''
    },
    subLabel: {
      type: String,
      default: ''
    },
    numericValue: {
      type: Boolean,
      default: true
    },
    excludedValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    options: function options() {
      var _this = this;

      var options = [];

      if (this.numericValue) {
        options = this.billedOptionsNumeric;
      } else {
        options = this.billedOptionsSlug;
      }

      if (this.excludedValue.length > 0) {
        return options.filter(function (obj) {
          return !_this.excludedValue.includes(obj.value);
        });
      }

      return options;
    }
  },
  data: function data() {
    return {
      billedOptionsNumeric: [{
        value: null,
        slug: 'any_state',
        description: '',
        label: this.$t('components.entries.any_state')
      }, {
        value: 2,
        slug: 'non-billable',
        description: this.$t('components.pickers.description_non_billable'),
        label: this.$t('general.not_billable')
      }, {
        value: 3,
        slug: 'billable',
        description: this.$t('components.pickers.description_billable'),
        label: this.$t('general.billable')
      }, {
        value: 0,
        slug: 'unbilled',
        description: this.$t('components.pickers.description_unbilled'),
        label: this.$t('general.unbilled')
      }, {
        value: 1,
        slug: 'billed',
        description: this.$t('components.pickers.description_billed'),
        label: this.$t('general.billed')
      }],
      billedOptionsSlug: [{
        value: null,
        slug: 'any_state',
        description: '',
        label: this.$t('components.entries.any_state')
      }, {
        value: 'non-billable',
        slug: 'non-billable',
        description: this.$t('components.pickers.description_non_billable'),
        label: this.$t('general.not_billable')
      }, {
        value: 'billable',
        slug: 'billable',
        description: this.$t('components.pickers.description_billable'),
        label: this.$t('general.billable')
      }, {
        value: 'unbilled',
        slug: 'unbilled',
        description: this.$t('components.pickers.description_unbilled'),
        label: this.$t('general.unbilled')
      }, {
        value: 'billed',
        slug: 'billed',
        description: this.$t('components.pickers.description_billed'),
        label: this.$t('general.billed')
      }]
    };
  },
  methods: {
    updateData: function updateData(val) {
      this.$emit('input', val);
    }
  }
};